import { LegalPage, Section } from "@/components/LegalPage";

export default function Cookies() {
  return (
    <LegalPage title="Cookie Policy" testId="cookies-title">
      <Section title="1. What Are Cookies?">
        <p>Cookies are small text files stored on your device. We also use <strong>localStorage</strong> (browser-side key-value storage) for some Platform features. Together these technologies let us keep you signed in and remember preferences.</p>
      </Section>

      <Section title="2. Cookies We Use">
        <ul>
          <li><strong><code>access_token</code></strong> (httpOnly, secure, 24h): keeps you signed in.</li>
          <li><strong><code>refresh_token</code></strong> (httpOnly, secure, 7d): refreshes your session.</li>
          <li><strong><code>session_token</code></strong> (httpOnly, secure, when using Emergent Google Auth): single-sign-on session.</li>
        </ul>
        <p>These are <strong>strictly necessary</strong> for the Platform to function and cannot be disabled without losing access.</p>
      </Section>

      <Section title="3. localStorage Items">
        <ul>
          <li><strong><code>bc_onboarding_dismissed_v1</code></strong>: remembers that you dismissed the onboarding modal.</li>
          <li><strong><code>bc_pwa_install_dismissed_v1</code></strong>: remembers that you dismissed the Install BeatCredsi prompt.</li>
        </ul>
      </Section>

      <Section title="4. Third-Party Cookies">
        <ul>
          <li><strong>Stripe</strong>: When you click "Subscribe" we redirect you to Stripe's hosted checkout. Stripe may set cookies for fraud prevention and session continuity. See <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer">Stripe's Cookie Policy</a>.</li>
          <li><strong>Emergent Auth</strong>: Google OAuth via <code>auth.emergentagent.com</code> may set transient session cookies.</li>
        </ul>
        <p>We do <strong>not</strong> currently use third-party advertising cookies, analytics trackers, or remarketing pixels.</p>
      </Section>

      <Section title="5. Service Worker &amp; Cache">
        <p>If you install BeatCredsi as a Progressive Web App or visit while online, a service worker caches static assets to enable offline access to the app shell. This cache contains no personal data. You can clear it via your browser's site settings.</p>
      </Section>

      <Section title="6. Managing Cookies">
        <p>You can block or delete cookies via your browser settings. Blocking strictly-necessary cookies will prevent you from signing in. Browser-specific instructions:</p>
        <ul>
          <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
          <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">Firefox</a></li>
          <li><a href="https://support.apple.com/guide/safari/manage-cookies-sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        </ul>
      </Section>

      <Section title="7. Updates">
        <p>We may update this Policy as we add new tools or analytics. Material changes will be announced via email or in-app notice.</p>
      </Section>

      <Section title="8. Contact">
        <p>Email <a href="mailto:contact@onlymartian.com">contact@onlymartian.com</a>.</p>
      </Section>
    </LegalPage>
  );
}
